import { EndAction } from "../../Models/End";

import DefaultEnd from "./Default";
import ArchiveConversation from "./ArchiveConversation";
import WebhookNotification from "./WebhookNotification";

export default EndConfig;

const EndActionRegistry = {
  [EndAction.NONE]: DefaultEnd,
  [EndAction.ARCHIVE_CONVERSATION]: ArchiveConversation,
  [EndAction.WEBHOOK_NOTIFICATION]: WebhookNotification,
};

function EndConfig(props) {
  const { node } = props;

  const EndAction = EndActionRegistry[node.data.endAction ?? "none"];

  return <EndAction {...props} />;
}
